export const USER_SESSION_ONLINE_MS = 5 * 60 * 1000;
export const USER_SESSION_TOUCH_MS = 60 * 1000;

export function isUserSessionOnline(params: {
  lastSeenAt: Date;
  endedAt: Date | null | undefined;
  now?: Date;
}): boolean {
  if (params.endedAt) {
    return false;
  }
  const now = params.now ?? new Date();
  return now.getTime() - params.lastSeenAt.getTime() <= USER_SESSION_ONLINE_MS;
}

export function sessionDurationMs(params: {
  startedAt: Date;
  lastSeenAt: Date;
  endedAt: Date | null | undefined;
}): number {
  const end = params.endedAt ?? params.lastSeenAt;
  return Math.max(0, end.getTime() - params.startedAt.getTime());
}
